var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"game-board",class:{'inactive': !_vm.activeCycle}},_vm._l((_vm.rowCount),function(row){return (_vm.rowCount)?_c('div',{key:row,staticClass:"board-row"},_vm._l((_vm.columnCount),function(column){return (_vm.columnCount)?_c('Tile',{key:row-column,ref:"tiles",refInFor:true,style:({
				width: (_vm.tileWidth + "px"),
				height: (_vm.tileHeight + "px"),
			}),attrs:{"catComponentType":_vm.catComponentType,"totalColumns":_vm.columnCount,"columnNumber":column}}):_vm._e()})):_vm._e()}))}
var staticRenderFns = []
export { render, staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-085e96ea","hasScoped":true,"optionsId":"0","buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/board/Board.vue
// module id = null
// module chunks = 